export default __webpack_public_path__ + "static/media/dados-img.97c7c024.png";